export default {
  channels: state => state.channels,
  users: state => state.users,
  userChannels: state => state.userChannels,
  messages: state => state.messages,
  isTyping: state => state.isTyping,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  token: state => state.token,
  pageSizeUser: state => state.pageSizeUser,
  searchTermUser: state => state.searchTermUser,
  tokenUser: state => state.tokenUser,
  isChannelChecked: state => state.isChannelChecked,
  isChannelNotSaved: state => state.isChannelNotSaved,
  isUserChecked: state => state.isUserChecked,
  requests: state => state.requests
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/getters.js